import { FgBlockType } from '../../block-type.js';
import { queueFgEvent, pumpFgEvent } from '../../event-bus.js';
import { FgEventType, FgType } from '../../types.js';
import { getDataValue, activateSignal } from '../../runtime.js';
import { sigOut, sigIn, sockIn } from '../../sockets.js';

const sendCustomEventDef = {
  type: FgBlockType.SendCustomEvent,
  build(config) {
    const valueNames = config?.valueNames ?? [];
    const valueTypes = config?.valueTypes ?? [];
    const valueDefaults = config?.valueDefaults ?? {};
    return {
      dataIn: valueNames.map((name, index) => sockIn(name, valueTypes[index] ?? FgType.Any, valueDefaults[name])),
      signalIn: [sigIn("in")],
      signalOut: [sigOut("out")]
    };
  },
  execute(block, ctx, env) {
    const eventId = block.config?.eventId ?? "";
    const valueNames = block.config?.valueNames ?? [];
    const values = {};
    for (const name of valueNames) {
      values[name] = getDataValue(ctx, env, block, name);
    }
    const dispatch = block.config?.dispatchEventsSynchronously === false ? queueFgEvent : pumpFgEvent;
    dispatch(env.events, FgEventType.CustomEvent, { eventName: eventId, values });
    activateSignal(ctx, env, block, "out");
  }
};

export { sendCustomEventDef };
//# sourceMappingURL=send-custom-event.js.map
